import styled, { css } from 'styled-components';

import { tokens } from '../../../../tokens';

interface SectionWrapperProps {
    $padded?: boolean;
    $stretch?: boolean;
}

export const SectionWrapper = styled.div<SectionWrapperProps>`
    flex: ${({ $stretch }) => ($stretch ? '1 1 auto' : '0 0 auto')};

    ${({ $padded }) =>
        $padded &&
        css`
            padding-left: ${tokens.spacing.tight}px;
            padding-right: ${tokens.spacing.tight}px;

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                padding-left: ${tokens.spacing.loose}px;
                padding-right: ${tokens.spacing.loose}px;
            }
        `}
`;
